// Legacy Dashboard - kept for backward compatibility
// New dashboard is in DashboardNew.tsx
import React from 'react';
import DashboardNew from './DashboardNew';

const Dashboard: React.FC = () => {
  return <DashboardNew />;
};

export default Dashboard;
